import { type PropsWithChildren, forwardRef } from "react";

import { cn } from "$/lib/utils/functions/misc.functions";
import { Tab } from "../../atoms";
import type { TabsProps } from "./Tabs.types";

const Tabs = forwardRef<HTMLDivElement, PropsWithChildren<TabsProps>>(
  (
    {
      type = "basic",
      tabs,
      activeTab,
      handleTabChange,
      className,
      tabClassName,
      navClassName,
      theme = "blue",
    },
    forwardedRef,
  ) => {
    return (
      <div
        ref={forwardedRef}
        className={cn(
          "w-fit",
          { "w-full border-b-[1px] border-tertiary-300": type === "basic" },
          className,
        )}
      >
        <div
          // className={cn({
          //   "flex rounded-lg bg-gray-200 px-2 py-1.5 transition duration-200 hover:bg-gray-200":
          //     type === "bordered",
          // })}
          className="w-full"
        >
          <nav
            className={cn("flex", navClassName)}
            aria-label="Tabs"
            role="tablist"
            aria-orientation="horizontal"
          >
            {tabs.map((tab) => (
              <Tab
                key={tab.id}
                tabType={type}
                tabObject={tab}
                isActive={activeTab === tab.id}
                onTabChange={handleTabChange}
                tabClassName={tabClassName}
                theme={theme}
              />
            ))}
          </nav>
        </div>
      </div>
    );
  },
);

Tabs.displayName = "Tabs";

export default Tabs;
